import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import ShippingItem from './ShippingItem';

import './styles/ShippingDataContent.css';

export default function ShippingDataContent({ shippingData, onSelectShippingData, onUpdateShippingData, onRemoveShippingData, close }) {
  return (
    <div className="shipping-data-content__container"> 
      <div className="shipping-data-content__header">
        <Text className="shipping-data-content__header-text" medium>
          Saved shipping rates
        </Text>
        <XIcon className="shipping-data-content__close" onClick={close} />
      </div>

      <Text className="shipping-data-content__text" paragraph small>
        Select, rename, or delete your saved shipping rates. 
        You can make further adjustments for specific scenarios when selecting.
      </Text>

      {shippingData.map(item => (
        <ShippingItem 
          key={item._id} 
          data={item}
          onSelectShippingData={onSelectShippingData}
          onUpdateShippingData={onUpdateShippingData}
          onRemoveShippingData={onRemoveShippingData}
        />
      ))}
      
    </div>
  );
}
